import React, { useState, useEffect } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Paper, PaperProps } from '@material-ui/core'
import Draggable from 'react-draggable';
import { useHistory, useLocation } from 'react-router-dom';
import IViewRequisitosRF from '../../view-interfaces/IViewRequisitosRF';
import { ObtieneRequisitosRFLogic } from '../DatosPersonales/DatosPersonales.logic';

type Props = {
    estado: boolean;
    onClick: any;
}

function PaperComponent(props: PaperProps) {
    return (
        <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper {...props} />
        </Draggable>
    );
}

export const RequisitosRL: React.FC<Props> = ({ estado, onClick }) => {
    const location = useLocation();
    const [open, setOpen] = useState(false);
    const [paso, setPaso] = useState(false);
    const lista: Array<IViewRequisitosRF> = [];
    const [requisitos, setRequisitos] = useState(lista);
    const [codNegocio, setCodNegocio] = useState(0)

    const handleClose = () => { setOpen(false); };
    const handleLimpiar = () => { }
    const handleValidarDatos = () => { }

    const selListaRequisitos = (error: Boolean, err: string, list: Array<IViewRequisitosRF>) => {
        try {
            if (error === false && list.length > 0) {
                if (codNegocio === 1) {
                    setRequisitos(list);
                } else {
                    setRequisitos(list.splice(0,3));
                }
                
            }
        } catch (er) {
    console.log('error', er)
}
    }

useEffect(() => {
    let _tt = JSON.stringify(location.state);
    let _params = JSON.parse(_tt)
    setCodNegocio(_params.CodigoNegocio)
    ObtieneRequisitosRFLogic(selListaRequisitos);
}, [])

return (
    <>
        <Dialog open={estado}
            onClose={handleClose}
            PaperComponent={PaperComponent}
            fullWidth={true}
            aria-labelledby="draggable-dialog-title">
            <DialogTitle id="draggable-dialog-title">REQUISITOS DEL RESPONSABLE LEGAL</DialogTitle>
            <DialogContent>
                {/* <p className="modal-description">En el pagaré se le denominará “Suscriptor”.</p> */}
                <ul className="modal-list">
                    {requisitos.map((row) => (
                        row.descripcion.indexOf('El seguro vida escolar comienza en marzo') === -1 ?
                            <li key={row.ID} className="modal-item"> {row.descripcion}</li>
                            :
                            <li key={row.ID} className="modal-item"> <strong >{row.descripcion}</strong></li>
                    ))}

                </ul>
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={() => { onClick(paso) }} color="primary" onBlur={handleLimpiar}>Salir</Button>
            </DialogActions>
        </Dialog>
    </>
)
}
